module.exports = __webpack_public_path__ + "static/heidi9-2e89e36a9748bdecef556954a242ba1d.jpg";